import RnaId from './RnaId';

export default RnaId;
